import { Box, Link } from '@factorialco/deprecated-design-system'
import { TransactionCardPaymentFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { DefaultPairTransactionDetails } from '../DefaultPairTransactionDetails'

export const SoftwarePaymentDetails = (cardPayment?: TransactionCardPaymentFragment | null) => {
  const { navigation } = useNavigation()
  if (!cardPayment || !cardPayment.softwarePayment) return null
  const softwareUrl = navigation.software.applications.applicationId.paymentId.fullPath({
    application_id: cardPayment.softwarePayment.softwareSetup?.id ?? '',
    paymentId: cardPayment.softwarePayment?.id ?? '',
  })

  return (
    <Box width="full" paddingTop="s16" gap="s32">
      <DefaultPairTransactionDetails
        desc1={i18n.t('expenses_v2.transactions.detail.fields.software')}
        val1={cardPayment.softwarePayment.softwareSetup?.software?.name}
        desc2=""
      />
      <Link.Router to={softwareUrl}>
        {i18n.t('expenses_v2.transactions.detail.actions.view_software_payment_details')}
      </Link.Router>
    </Box>
  )
}
